import { render, staticRenderFns } from "./CrewBookings.vue?vue&type=template&id=f0c51050&scoped=true&"
import script from "./CrewBookings.vue?vue&type=script&lang=js&"
export * from "./CrewBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c51050",
  null
  
)

export default component.exports